export default class BaseFieldModel {
  rules = {}
  type = null
  key = null
  label = null
  field_class_name = null

  constructor(data = {}) {
    Object.assign(this, {...data});
  }

  getChoices() {
    return [];
  }

  isAppendable() {
    return false;
  }

  isMultiple() {
    return false;
  }

  hasCharCounter() {
    return false;
  }
}
